import type { SVGProps } from 'react';

const UserSvgIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={32}
    height={32}
    viewBox="0 0 32 32"
    fill="none"
    {...props}
  >
    <path
      d="M10.5 17C13.5376 17 16 20.134 16 24H5C5 20.134 7.46243 17 10.5 17ZM20 15C23.8659 15.0001 27 19.0295 27 24H17.5C17.5 21.5689 16.6141 19.1933 15.0996 17.5742C16.3623 15.9822 18.0918 15.0001 20 15ZM10.5 11C11.8807 11 13 12.1193 13 13.5C13 14.8807 11.8807 16 10.5 16C9.11929 16 8 14.8807 8 13.5C8 12.1193 9.11929 11 10.5 11ZM20 8C21.6569 8 23 9.34315 23 11C23 12.6569 21.6569 14 20 14C18.3431 14 17 12.6569 17 11C17 9.34315 18.3431 8 20 8Z"
      fill="#333333"
    />
  </svg>
);
export default UserSvgIcon;
